import api from './api';

export const listRoomFrames = (roomId, params = {}) => {
  const q = {};
  if (params.startDate) q.start_date = params.startDate;
  if (params.endDate) q.end_date = params.endDate;
  if (params.minPeople !== undefined) q.min_people = params.minPeople;
  if (params.maxPeople !== undefined) q.max_people = params.maxPeople;
  if (params.sortBy) q.sortBy = params.sortBy;
  if (params.sortOrder) q.sortOrder = params.sortOrder;
  if (params.limit) q.limit = params.limit;
  if (params.offset) q.offset = params.offset;
  q.is_total_needed = true

  return api.get(`/rooms/${roomId}/frames`, { params: q }).then(r => r.data);
};

export const listFrames = (cameraId, params = {}) => {
  const allParams = {...params, is_total_needed: true}
  return api.get(`/cameras/${cameraId}/frames`, { params:allParams }).then(r => r.data);
}

export const getFrame = (frameId) => {
  return api.get(`/frames/${frameId}`).then(r => r.data);
};

export const exportRoomFramesXlsx = (roomId, params = {}) => {
  return api.get(`/rooms/${roomId}/export/xlsx`, {
    params,
    responseType: "blob",
  });
};
